import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Auth from '../auth';
import ApiService from '../apiService';
import FormValidator from '../view/component/formValidator';
import { InputAlert } from '../view/component/InputAlert';
import validationRules from './validationRules';
import Alert from '../view/component/Alert';

export default class Login extends Component {
  state = {
    username: '',
    password: '',
    captchaUrl: '',
    captchaUuid: '',
    captcha: '',
    auth: false,
    wasValidated: false,
  };

  formValidator = new FormValidator(validationRules);

  validation = this.formValidator;
  componentDidMount() {
    this.getCaptca();
  }

  getCaptca = async () => {
    const res = await ApiService.get('captchaInfo');
    if (res) {
      this.setState({
        captchaUrl: res.captchaUrl,
        captchaUuid: res.captchaUuid,
      });
    }
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = async (event, validation) => {
    console.log(validation);
    event.preventDefault();
    this.setState({ wasValidated: false });

    if (validation.isValid) {
      const auth = new Auth();

      const user = {
        username: this.state.username,
        password: this.state.password,
        captcha: this.state.captcha,
        captchaUuid: this.state.captchaUuid,
      };

      const res = await ApiService.post('auth/login', user);

      if (res) {
        if (res.status === 'Success') {
          auth.authenticate(res);

          this.setState({ auth: true });
        } else {
          this.getCaptca();
          Alert('error', res.data.status);
        }
      }
    } else {
      this.setState({ wasValidated: true });
    }
  };
  _handleKeyDown = (validation) => (e) => {
    if (e.key === 'Enter') {
      this.handleSubmit(e, validation);
    }
  };

  render() {
    const validation = this.validation.validate(this.state);
    const wasValidated = this.state.wasValidated;

    const ColoredLine = ({ color }) => (
      <hr
        style={{
          color: color,
          backgroundColor: color,
          width: 100,
          height: 2,
          marginTop: 0,
          marginBottom: 40,
        }}
      />
    );
    const ColoredLine2 = ({ color }) => (
      <hr
        style={{
          color: color,
          backgroundColor: color,
          width: 50,
          height: 2,
          marginTop: 0,
        }}
      />
    );

    if (this.state.auth) {
      setTimeout(() => {
        // return <Redirect to="/home" />;
        this.props.history.push('/home');
      }, 1000);
    }

    return (
      <div>
        {/* Main content */}
        <div
          className="main-content pb-8"
          style={{ backgroundImage: 'url(assets/img/theme/bg-login2.png)' }}
        >
          <div className="header  py-8 py-lg-8 pt-lg-8">
            <div className="container">
              <div className="header-body text-center mb-7" />
            </div>
          </div>
          {/* Page content */}
          <div className="container mt--7 pb-8">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="pricing card-group flex-column flex-md-row mb-3">
                  <div className="card card-pricing border-0 shadow-lg mb-4 rounded-left bg-success">
                    <div className="card-body px-lg-7">
                      <div className="row justify-content-center">
                        <div className="row justify-content-center mt-7 container">
                          <img
                            src="assets/img/theme/img-logo.png"
                            width="85px"
                            height="85px"
                          />
                        </div>
                        <div className="row justify-content-center container">
                          <div className="mt-4 justify-content-center pb-7">
                            <h1 className="text-white text-center">
                              SMART CLINIC
                            </h1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card card-pricing bg-secondary shadow-lg rounded-right border-0 text-center mb-4">
                    <div className="card-body px-lg-5 py-lg-5">
                      <div className="text-center text-muted mb-4">
                        <h2 className="text-uppercase ls-1 py-1 mb-0">Masuk</h2>
                        <ColoredLine2 color="#2dce89" />
                      </div>
                      <form>
                        <div className="form-group mb-3">
                          <div className="input-group input-group-merge input-group-alternative">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="ni ni-email-83 text-success" />
                              </span>
                            </div>
                            <input
                              className="form-control"
                              name="username"
                              onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                  this.password.focus();
                                }
                              }}
                              placeholder="Username"
                              type="text"
                              onChange={this.onChange}
                              autoComplete="off"
                            />
                          </div>
                          <InputAlert
                            validation={validation.username}
                            wasValidated={wasValidated}
                          />
                        </div>
                        <div className="form-group">
                          <div className="input-group input-group-merge input-group-alternative">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="ni ni-lock-circle-open text-success" />
                              </span>
                            </div>
                            <input
                              className="form-control"
                              ref={(ref) => (this.password = ref)}
                              name="password"
                              onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                  this.captcha.focus();
                                }
                              }}
                              placeholder="Password"
                              type="password"
                              onChange={this.onChange}
                              autoComplete="off"

                            />
                          </div>
                          <InputAlert
                            validation={validation.password}
                            wasValidated={wasValidated}
                          />
                        </div>
                        <div className="form-group">
                          <div className="card mx-5">
                            <img
                              className="card-img-top m-0 p-0"
                              src={this.state.captchaUrl}
                            />
                            <div className="card-body pt-2">
                              <a
                                href="#captcha"
                                onClick={this.getCaptca}
                                onClickCapture={() => {
                                  this.captcha.focus();
                                }}
                                className="h5 badge badge-pill badge-primary px-2"
                              >
                                muat ulang captcha
                              </a>
                              <div className="input-group input-group-merge mt-2">
                                <input
                                  className="form-control"
                                  ref={(ref) => (this.captcha = ref)}
                                  name="captcha"
                                  onKeyDown={this._handleKeyDown(validation)}
                                  placeholder="Masukkan Captcha"
                                  type="text"
                                  onChange={this.onChange}
                                  autoComplete="off"
                                />
                              </div>
                              <InputAlert
                                validation={validation.captcha}
                                wasValidated={wasValidated}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="text-center">
                          <button
                            type="button"
                            className="btn btn-block btn-success"
                            onKeyDown={this._handleKeyDown(validation)}
                            onClick={(event) =>
                              this.handleSubmit(event, validation)
                            }
                            onKeyDown={this._handleKeyDown}
                          >
                            Masuk
                          </button>
                        </div>
                      </form>
                    </div>
                    <div className="row align-items-center justify-content-lg-between">
                      <div className="col-lg-12 m-3">
                        <div className="copyright text-center text-sm-left text-muted">
                          <div style={{ fontSize: '11px' }}>
                            © 2019
                            <a
                              href="https://sisfomedika.com"
                              className="font-weight-bold ml-1"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Sisfomedika
                            </a>
                            &nbsp;Version 1.0 - All Rights Reserved
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
